import { FACETS_LOCATION_NAME, FACETS_LOCATION_REGEX_RADIUS } from '../constants';
import { HANDLE_CLICK } from '../search/actions/_types';

export default (state) =>
  ({ [HANDLE_CLICK]: handleClick }) => {
    const {
      search: { facets },
    } = state;

    // Is there a location facet applied?
    const locationFacet = facets.find(({ name }) => name === FACETS_LOCATION_NAME) || { items: [] };
    const locationData = locationFacet.items[0];
    const { label: locationLabel } = locationData || { label: '' };

    let titleSuffix = '';
    const moreInfo = {
      paragraph: "We couldn't find any events that match those criteria.",
      preLink: 'Try broadening your search by removing filters or check out the ',
      postLink: ' happening across the country.',
    };
    const linkText = 'full\u00a0list\u00a0of\u00a0events';

    if (locationLabel) {
      titleSuffix = ` near ${locationLabel.replace(FACETS_LOCATION_REGEX_RADIUS, '')}`;
    }

    const title = `Sorry, no events found${titleSuffix}`;
    const link = '/events/search';

    return {
      title,
      moreInfo,
      link: {
        attrs: {
          href: link,
        },
        on: {
          click: (event) =>
            handleClick({
              external: true,
              event,
              to: link,
              analytics: {
                section: 'city links',
                linkText: 'More Cities',
              },
            }),
        },
        text: linkText,
      },
    };
  };
